angular.module("acl.common.sessionManager").controller("SessionController", function($scope, $modalInstance) {
  "use strict";
  $scope.close = function() {
    $modalInstance.dismiss();
    window.location.assign("/");
    window.location.reload(true);
  };
});
